module.exports = __webpack_public_path__ + "static/assets/3194f6d7a9b39041c9c7f273be2d699c.png";